import { Grid, Stack } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import type { PartyDto } from "Infrastructure/Api/Api";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";
import { formatPhone } from "Utils/PhoneUtils";

const FORM_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form.NaturalPerson;

type Props = {
  party: PartyDto;
  genderValue?: string;
};

export const NaturalPersonSection = ({
  party: {
    firstName,
    lastName,
    personalNumber,
    birthDate,
    birthPlace,
    nationality,
    otherNationalities,
    phone,
    verifiedPhone,
    email,
  },
  genderValue,
}: Props) => {
  const { t } = useResource();
  const { getCountryName, getCountryNames } = useCountryNameResolver();

  return (
    <Stack gap={4}>
      <FormSection legend={t(FORM_RESOURCES.Legend.PersonalData)} noMargins>
        <Grid container spacing={2}>
          <GridItem label={t(FORM_RESOURCES.FirstName)} value={firstName} />
          <GridItem label={t(FORM_RESOURCES.LastName)} value={lastName} />
          <GridItem
            label={t(FORM_RESOURCES.PersonalNumber)}
            value={personalNumber}
          />
          <GridItem
            label={t(FORM_RESOURCES.BirthDate)}
            value={formatDate(birthDate)}
          />
          <GridItem label={t(FORM_RESOURCES.Gender)} value={genderValue} />
          <GridItem label={t(FORM_RESOURCES.BirthPlace)} value={birthPlace} />
          <GridItem
            label={t(Resources.Common.Nationality)}
            value={getCountryName(nationality)}
          />
          {otherNationalities.length > 0 && (
            <GridItem
              label={t(Resources.Common.OtherNationalities)}
              value={getCountryNames(otherNationalities)}
            />
          )}
        </Grid>
      </FormSection>
      <FormSection legend={t(FORM_RESOURCES.Legend.Contact)} noMargins>
        <Grid container spacing={2}>
          <GridItem
            columns={2}
            label={t(FORM_RESOURCES.Phone)}
            value={formatPhone(phone)}
          />
          <GridItem
            columns={2}
            label={t(FORM_RESOURCES.VerifiedPhone)}
            value={formatPhone(verifiedPhone)}
          />
          <GridItem columns={2} label={t(FORM_RESOURCES.Email)} value={email} />
        </Grid>
      </FormSection>
    </Stack>
  );
};
